export const environment = {
  production: true,
  CLIENT_ID: '30d7fd89-bd19-446f-946a-94c55d48d21f',
  GRANT_TYPE: 'password',
  TOASTER_POSITION: 'toast-top-right',
  TOASTER_TIMEOUT: 3000
};
